import { render, staticRenderFns } from "./DoseCalculator.vue?vue&type=template&id=6d328d98"
import script from "./DoseCalculator.vue?vue&type=script&lang=js"
export * from "./DoseCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports